import { observable, action } from 'mobx'
import { responseDefault } from './store.constants'
import { isEmpty } from 'lodash'
import { Request3 } from 'src/common/Request3'
import api from 'src/common/api'
import { ERROR_CODES, PAGE_SIZE, typeFund } from 'src/helpers/constants'
// import { fundListFake, priceFundFake } from './fakeData'
export const listFundInit = {
   results: [],
   limit: 50,
   page: 1,
   totalPages: 1,
   totalResults: 0,
   collect: 0,
   pay: 0,
   totalAfter: 0
}
export class FundStore {
   @observable listFund: any = listFundInit
   @observable productListList: any = []
   @observable fundList: any = { ...responseDefault }
   @observable importExportList: any = { ...responseDefault }
   @observable importExportBillList: any = { ...responseDefault }
   @observable productWithStoreList: any = []
   @observable priceFund: any = {
      before: 0,
      collect: 0,
      spend: 0,
      after: 0
   }

   @observable listTypesReceipts: any = {
      results: [{}],
      limit: 50,
      page: 1,
      totalPages: 1,
      totalResults: 0
   }

   @observable listTypesReceiptsFilter: any = {
      results: [],
      limit: 1000,
      page: 1,
      totalPages: 1,
      totalResults: 0
   }

   @observable listTypesReceiptsFilterCreateDetail: any = {
      results: [],
      limit: 1000,
      page: 1,
      totalPages: 1,
      totalResults: 0
   }

   @observable listGroupUser: any = {
      staff: 'staff',
      customer: 'customer',
      // partner: 'partner',
      ncc: 'ncc',
      other: 'other'
   }

   @observable fundSelected: any = null
   @action
   async setFundSelected(item: any) {
      this.fundSelected = item
   }

   @action
   async getFundList(params: any = {}) {
      // this.fundList=fundListFake
      // return;
      const result = await Request3.getWithToken(api.funds.getList, { ...params, ...{ limit: PAGE_SIZE } })
      console.log('getFundList', result?.data)

      if (!isEmpty(result?.data)) {
         this.fundList = result?.data
      }
   }

   @action
   async createFund(params: any = {}) {
      // console.log('params: ', params, 'api.funds.create: ', api.funds.create);

      const result = await Request3.postWithToken(api.funds.create, params)
      console.log('result: createFund', result)
      if (params?.type === typeFund.WITHDRAW || params?.type === typeFund.RECHARGE) {
         return result
      }
      return result?.data
   }
   @action
   async updateFund(id: any, params: any = {}) {
      // console.log('params: ', params, 'api.funds.create: ', api.funds.create);

      const result = await Request3.postWithToken(api.funds.create, params)
      // console.log('result: ', result);
      if (params?.type === typeFund.WITHDRAW || params?.type === typeFund.RECHARGE) {
         return result
      }
      return result?.data
   }

   @action
   async approveFund(id: string | number, params: any = {}, history?: any) {
      console.log('params: ', params, 'api.funds.create: ', api.funds.approve)

      const result = await Request3.postWithToken(api.funds.approve + '/' + id, params)
      // console.log('result: ', result);
      return result?.data
   }

   @action
   async getTotalPrice(from: string, to: string) {
      // this.priceFund=priceFundFake
      // return;
      const result = await Request3.getWithToken(api.funds.total, { from, to })
      console.log('getTotalPrice____', result?.data)

      if (!isEmpty(result?.data)) {
         this.priceFund = result?.data
      }
   }

   @action
   async resetStoreDebts() {
      this.listFund = { ...listFundInit }
   }
}
